import React from "react";
import DashboardProducts from "../Components/DashboardComponents/DashboardProducts.jsx";
import DashboardAside from "../Components/DashboardComponents/DashboardAside/DashboardAside.jsx";
import { FilterProvider } from "../Context/FilterContext.jsx";
import { DashboardProvider } from "../Context/DashboardContext.jsx";
import { Routes, Route } from "react-router-dom";
import DashboardHeader from "../Components/DashboardComponents/DashboardHeader.jsx";
import MainDashboard from "../Components/DashboardComponents/MainDashboard.jsx";
import { NotFound } from "./404.jsx";
import { useLocation } from "react-router-dom";
const DashboardPage = () => {
  const location = useLocation();

  if (
    !["", "dashboard", "products"].includes(location.pathname.split("/").pop())
  ) {
    return <NotFound />;
  }

  return (
    <DashboardProvider>
      <FilterProvider>
        <div className="flex flex-col bg-white w-full h-full">
          <DashboardHeader />

          <div className="flex w-full h-full">
            <DashboardAside />
            {
              /*
                    <Route path='/especials' element={<h1>Especiales</h1>} />
                    <Route path='/help' element={<h1>Help</h1>} />
                    <Route path='/settings' element={<h1>Settings</h1>} />
                    <Route path='/top-sellers' element={<h1>Top sellers</h1>} />
                    */

              <Routes>
                <Route path="/" element={<MainDashboard />} />
                <Route path="/products" element={<DashboardProducts />} />
              </Routes>
            }
          </div>
        </div>
      </FilterProvider>
    </DashboardProvider>
  );
};

export default DashboardPage;
